import classNames from "classnames";
import Styles from "./Card.module.scss";

const Card3 = ({ img, title, description, date, onClick }) => {
  return (
    <div className={classNames("col-12", Styles.card_3)} onClick={onClick}>
      <div
        className={classNames("col-2", Styles.card_3__img)}
        style={{
          backgroundImage: `url(${img})`,
          height: "15vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* <img src="../../assets/images/index/交通接送.jpg" alt="NOOOOOOOO" /> */}
      </div>

      <div className={classNames("col-10")}>
        <div className={classNames(Styles.card_3__content)}>
          <div className={Styles.card_3__title}>{title}</div>

          <div className={Styles.card_3__date}>{date}</div>
        </div>

      </div>
    </div>
  );
};

export default Card3;
